import React from 'react';
import { Column, Copy, Row } from '@grubhubprod/gh-cookbook-react';
import {
  Loader,
  Flex,
  Stack,
  Square,
} from '@grubhubprod/gh-cookbook-react/dist';
import { RestrictionsList } from 'src/common/OrderRestrictions/RestrictionsList/RestrictionsList';
import { MerchantRestrictionsEnableControl } from 'src/components/enterprise/features/Corporate/components/Form/MerchantRestrictionsWrapper/MerchantRestrictionsEnableControl';
import { useToggleRestrictions } from 'src/components/enterprise/features/Corporate/components/Form/common/hooks/useToggleRestrictions';
import { useCorporateMerchantRestrictions } from 'src/components/enterprise/features/Corporate/components/Form/MerchantRestrictionsWrapper/hooks/useCorporateMerchantRestrictions';
import { useGroupCheckboxValidate } from 'src/components/CookbookCheckboxWrapper/hooks/useGroupCheckboxValidate';
import { requiredRestrictionsValidator } from 'src/common/OrderRestrictions/orderRestrictions.utils';

export function MerchantRestrictionsWrapper(): JSX.Element {
  const restrictionsEnabled = useToggleRestrictions({
    restrictionsFieldName: 'defaultMerchantRestrictions',
    toggleFieldName: 'enableMerchantRestrictions',
  });

  const { isLoading, groupedMerchantRestrictions, merchantRestrictionsMeta } =
    useCorporateMerchantRestrictions();

  const { error, validate } = useGroupCheckboxValidate({
    optionKeys: (merchantRestrictionsMeta || []).map(
      (restriction) => restriction.type
    ),
    name: 'defaultMerchantRestrictions',
    validateGroup: requiredRestrictionsValidator,
  });

  if (isLoading) {
    return (
      <Flex alignItems="center" justifyContent="center">
        <Loader size="md" />
      </Flex>
    );
  }

  return (
    <>
      <Row gutter={12}>
        <Column phone={6} gutter={12}>
          <MerchantRestrictionsEnableControl
            name="enableMerchantRestrictions"
            id="enableMerchantRestrictions"
          />
        </Column>
        {error && (
          <Column phone={12} gutter={12}>
            <Stack y="sm">
              <Copy variant="body" color="danger">
                {error.message}
              </Copy>
            </Stack>
          </Column>
        )}
      </Row>
      {restrictionsEnabled && (
        <Square bg="globals.white" inset="lg" dimension="1">
          <Row gutter={12}>
            <Column phone={12} gutter={12}>
              <Stack y="sm">
                <Copy variant="body">
                  We recommend each company follow their internal ordering
                  policies or guidelines to enforce these restrictions. The
                  accuracy of our restricted merchant categories is not
                  guaranteed. Restrictions will apply to new meal credits but
                  can be modified by an admin.
                </Copy>
              </Stack>
            </Column>
            <Column phone={12} gutter={12}>
              <RestrictionsList
                groupedRestrictions={groupedMerchantRestrictions}
                name="defaultMerchantRestrictions"
                rules={{
                  validate,
                }}
              />
            </Column>
          </Row>
        </Square>
      )}
    </>
  );
}
